<template>
  <div class="slc_w mb-x custom-radio">
    <label
        v-for="option in stornoOptions"
        :key="option.value"
        class="slc"
        :class="{ slc_ac: modelValue === option.value }"
        @click="$emit('update:modelValue', option.value)"
        @mouseover="hoveredItem = option.value" @mouseleave="hoveredItem = null"
    >
      <input
          type="radio"
          name="storno_type"
          :value="option.value"
          :checked="modelValue === option.value"
          class="hidden"
          tabindex="-1"
      />
      <img :src="option.icon" loading="lazy" alt="" class="slc_i" />
      <div>{{ option.label }}</div>
    </label>
    <div class="info">
      <small>
        Zrušenie cesty (tzv. storno) pred odchodom si môžete pripoistiť k cestovnému poisteniu. Poistná suma zodpovedá celkovej cene leteniek, vstupeniek alebo zájazdu za všetky osoby. Predčasný návrat z cesty je krytý v základnom rozsahu do výšky 600 EUR.
      </small>
    </div>


  </div>

<!--  <div class="space-holder">-->
<!--    <div class="slc_w mb-x" v-if="[modelValue, hoveredItem].includes('ADDON')" >-->
<!--      <div class="slc_info">-->
<!--        <div class="icoc">-->
<!--          <div></div>-->
<!--        </div>-->
<!--        <div class="co">-->
<!--          <div class="px mb">STORNO - zrušenie cesty pred odchodom<br></div>-->
<!--          <div class="ps">-->
<!--            pripoistenie k cestovnému poisteniu<br>-->
<!--            poistná suma - cena letenky / vstupenky / zájazdu - pre všetky osoby spolu<br>-->
<!--            predčasný návrat je krytý v základnom rozsahu na limit 600 EUR-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="slc_w mb-x" v-else-if="[modelValue, hoveredItem].includes('SEPARATE')">-->
<!--      <div class="slc_info">-->
<!--        <div class="icoc">-->
<!--          <div></div>-->
<!--        </div>-->
<!--        <div class="co">-->
<!--          <div class="px mb">STORNO - zrušenie cesty pred odchodom + predčasný návrat</div>-->
<!--          <div class="ps">-->
<!--            samostatné poistenie<br>-->
<!--            poistná suma - cena letenky / vstupenky / zájazdu - pre všetky osoby spolu</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import Options from "@/config/options";
export default {
  name: 'StornoRadio',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      hoveredItem: null,
      stornoOptions: Options.storno_type,
    }
  },
}
</script>

<style scoped>
.space-holder{
  min-height: 120px;
}
.info{
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  max-width: 50%;

  small{
    //line-height: 1.7;
    //width: 100%;
  }
}
@media all and (max-width: 960px) {
  .info{
    max-width: 100%;
  }
}
</style>
